import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function AlertsButton({...params}){

    const { mode } = useContext(ThemeContext);

    let alertsButtonState = params.alertsButtonState
    let setAlertsButtonState = params.setAlertsButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-alerts-light-active.svg", "/icons/icons-light/icon-alerts-light-default.svg", "/icons/icons-light/icon-alerts-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-alerts-dark-active.svg", "/icons/icons-dark/icon-alerts-dark-default.svg", "/icons/icons-dark/icon-alerts-dark-hover.svg"]

    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/alertspage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setAlertsButtonState('hover')
        else if (alertsButtonState !== 'active') setAlertsButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setAlertsButtonState('default')
        if (onButtonPage) setAlertsButtonState('active')
        else if (alertsButtonState !== 'active') setAlertsButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (alertsButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (alertsButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (alertsButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (alertsButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (alertsButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (alertsButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '38px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'35px'} height={'45px'} paddingBottom={'10px'}  id={"AlertsButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Alerts</Typography>
        </Stack>
    )
}
